import { storeToRefs } from 'pinia';
import { useManageJobStore } from '@/stores/useManageJob';

/**
 * If selectedJob is an empty object then we know a job is being accessed through a direct link
 * Fetch the job information before rendering the page so that is available ahead of time
 */
export default defineNuxtRouteMiddleware(async (to) => {
  const jobId = to.params.editIdSlug;

  const manageJobStore = useManageJobStore();
  const { selectedJob } = storeToRefs(manageJobStore);

  if (!selectedJob.value?.id) {
    await manageJobStore.getJobByID(jobId);

    /**
     * Check if current status is NOT posted
     * This can happen is a user cancels a job and tries to
     * directly access it with a UUID
     */
    const slug = getSlugByJobStatus(selectedJob.value?.status);
    if (!slug) {
      return navigateTo('/manage-jobs');
    }
  }
});
